module.exports = __webpack_public_path__ + "img/header-profile-skin-3.bf471ec3.png";